import axios from 'axios';
import { TYPE } from './types';
import * as Constants from '../../constants';
import { validateReqBodyFn, requestHeadersKeyValues } from './validateRequestBodyFn';


export function checkSessionStatus(data) {
    let apiToken = JSON.parse(localStorage.getItem(Constants.USER_DATA)).token;
    let sessionId = JSON.parse(localStorage.getItem(Constants.USER_DATA)).session_id;

    const authApi = Constants.HOTEL_API + '/' + TYPE.AUTH;
    const request = axios
        .post(authApi, data, {
            headers: requestHeadersKeyValues()
        })
        .then(response => {
            if (response.data.status === "SUCCESS" && response.data.data.token && response.data.data.token.length > 20) {
                response.data.selectedHotelID = localStorage.getItem(Constants.SELECTED_HOTEL_ID)
                response.data.selectedHotelName = localStorage.getItem(Constants.SELECTED_HOTEL_NAME)
                if(response.data.data.hotels !== undefined){
// local storage hotels array

                    let hotelDetailsObj = response.data.data.hotels.filter((item) => item.hotel_id === localStorage.getItem(Constants.SELECTED_HOTEL_ID))
                    if (hotelDetailsObj[0] !== undefined) {
                        response.data.hotelDetailObj = hotelDetailsObj[0]
                    }
                }
                response.data.isSessionValid = true
                response.data.slotsMapped = response.data
            } else {
                response.data.isSessionValid = false
            }

            return response.data;
        });
    return {
        type: TYPE.AUTH,
        payload: request
    }
}

export function clearSession() {
    localStorage.clear();
    let response = Object();
    response.data = Object();
    response.data.isSessionValid = false
    return {
        type: TYPE.CLEAR_SESSION,
        payload: response
    }
}

